
const MODULE_CONFIGS = [
    // --- Attipas ---
    {
        id: 'attipas-first-step',
        name: 'Attipas First Step',
        filter: 'Todo o ano',
        link: "<a href='https://gotu.pt/collections/attipas-calcado-classico?filter.v.availability=1'>Attipas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/attipas_6f6a4ef5-4e67-466a-9e3b-953aacff2e12.png?v=1718377210',
        imageAlt: 'Attipas First Step shoes',
        calculationType: 'lookup', // Lookup: Warnings are IN the table
        lookupTable: [
            { min: -Infinity, max: 97, size: "👇👟", width: "" },
            { min: 98, max: 108, size: "19-S", width: "55mm" },
            { min: 109, max: 115, size: "20-M", width: "56mm" },
            { min: 116, max: 125, size: "21.5-L", width: "62mm" },
            { min: 126, max: 135, size: "22.5-XL", width: "64mm" },
            { min: 136, max: 145, size: "24-XXL", width: "64mm" },
            { min: 146, max: 155, size: "25.5-XXXL", width: "70mm" },
            { min: 156, max: Infinity, size: "🤚🩰", width: "" },
        ]
    },
    {
        id: 'attipas-skinshoes',
        name: 'Attipas Skin Shoes',
        filter: 'Todo o ano',
        link: "<a href='https://gotu.pt/collections/attipas-skin-shoes'>Attipas: Skin Shoes</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/AttipasSkinpreview.png?v=1720460914',
        imageAlt: 'Attipas Skin Shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            143: { size: "23/24", width: "62mm" }, 154: { size: "25", width: "64mm" },
            164: { size: "26/27", width: "66mm" }, 172: { size: "28", width: "68mm" },
            180: { size: "29/30", width: "70mm" }, 193: { size: "31", width: "73mm" },
            202: { size: "32/33", width: "74mm" }
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Slip Stop ---
    {
        id: 'slipstop',
        name: 'Slip Stop',
        filter: 'Verão',
        link: "<a href='https://gotu.pt/collections/colecao-slip-stop'>Slip Stop</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/slipstop.png?v=1718377211',
        imageAlt: 'Slip Stop shoes',
        calculationType: 'lookup', // Lookup: Warnings are IN the table
        lookupTable: [
            { min: -Infinity, max: 109, size: "👇👟", width: "" },
            { min: 110, max: 131, size: "18,<br>19,<br>20", width: "" },
            { min: 132, max: 148, size: "21,<br>22,<br>23", width: "" },
            { min: 149, max: 166, size: "24,<br>25,<br>26", width: "" },
            { min: 167, max: 182, size: "27,<br>28,<br>29", width: "" },
            { min: 183, max: 208, size: "30,<br>31,<br>32", width: "" },
            { min: 209, max: 220, size: "33,<br>34,<br>35", width: "" },
            { min: 221, max: 226, size: "35,<br>36", width: "" },
            { min: 227, max: 239, size: "37,<br>38", width: "" },
            { min: 240, max: 245, size: "39,<br>40", width: "" },
            { min: 246, max: 252, size: "40,<br>41", width: "" },
            { min: 253, max: 271, size: "42,<br>43", width: "" },
            { min: 272, max: 278, size: "43,<br>44", width: "" },
            { min: 279, max: Infinity, size: "🤚🩰", width: "" },
        ]
    },
    // --- Zas Tras ---
    {
        id: 'zastras',
        name: 'Zas Tras',
        filter: 'Todo o ano',
        link: "<a href='https://gotu.pt/collections/zas-tras-booties'>Zás Trás</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/zastras_58753249-9007-4c16-9d11-1bc5ade4a405.png?v=1718377210',
        imageAlt: 'Zas Tras booties',
        calculationType: 'lookup', // Lookup: Warnings are IN the table
        lookupTable: [
            { min: -Infinity, max: 74, size: "👇👟", width: "" },
            { min: 75, max: 87, size: "0-3", width: "" },
            { min: 88, max: 95, size: "3-6", width: "" },
            { min: 96, max: 105, size: "6-12", width: "" },
            { min: 106, max: 125, size: "12-18", width: "" },
            { min: 126, max: 130, size: "18-24", width: "" },
            { min: 131, max: 145, size: "24-36", width: "" },
            { min: 146, max: Infinity, size: "🤚🩰", width: "" },
        ]
    },
    {
        id: 'zastras-fluffy',
        name: 'Zas Tras Fluffy',
        filter: 'Todo o ano',
        link: "<a href='https://gotu.pt/collections/zas-tras-booties'>Zás Trás: Fluffy</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/fluffy.png?v=1729263448',
        imageAlt: 'Zas Tras Fluffy booties',
        calculationType: 'lookup', // Lookup: Warnings are IN the table
        lookupTable: [
            { min: -Infinity, max: 94, size: "👇👟", width: "" },
            { min: 95, max: 107, size: "6-12", width: "" },
            { min: 108, max: 115, size: "12-18", width: "" },
            { min: 116, max: 125, size: "18-24", width: "" },
            { min: 126, max: Infinity, size: "🤚🩰", width: "" },
        ]
    },
    {
        id: 'zastras-waterproof',
        name: 'Zas Tras Waterproof',
        filter: ["À prova de água", "Inverno"],
        link: "<a href='https://gotu.pt/collections/zas-tras-booties'>Zas Tras: Waterproof</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Zastraswaterproof.png?v=1730732702',
        imageAlt: 'Zas Tras Waterproof booties',
        calculationType: 'margin',
        marginLogic: { base: 5, length: 5, minMargin: 5, maxMargin: 9 }, // Ensure these are correct
        sizeMap: {
            125: { size: "12-18", width: "56mm" },
            135: { size: "18-24", width: "58mm" },
            150: { size: "24-36", width: "63mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Froddo Prewalker ---
    {
        id: 'froddo-prewalker',
        name: 'Froddo PreWalker',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/froddo-prewalkers'>Froddo: PreWalker</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_Prewalker.png?v=1739305252',
        imageAlt: 'Froddo PreWalker shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            112: { size: "18", width: "52mm" },
            138: { size: "23", width: "52mm" }, // Large size jump
        },
         // warningCases removed - rely on auto-generation
    },
    {
        id: 'froddo-prewalker-classic',
        name: 'Froddo PreWalker Classic',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/froddo-prewalkers'>Froddo: PreWalker Classic</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_Prewalker_Classic.png?v=1739306019',
        imageAlt: 'Froddo PreWalker Classic shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            109: { size: "18", width: "51mm" },
            115: { size: "19", width: "51mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Froddo Sandals ---
    {
        id: 'froddo-sandalia-com-divisoria',
        name: 'Froddo Sandália (Com Divisória)',
        filter: ["Todo o ano","Verão"],
        link: "<a href='https://gotu.pt/collections/froddo-sandalia'>Froddo: Sandália (Com Divisória)</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_Sandalia_Com_Divisoria.png?v=1739306902',
        imageAlt: 'Froddo Sandália Com Divisória',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Sandal margin
        sizeMap: {
            237: { size: "36", width: "90mm" },
            245: { size: "37", width: "89mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'froddo-sandalia-sem-divisoria',
        name: 'Froddo Sandália (Sem Divisória)',
        filter: ["Todo o ano","Verão"],
        link: "<a href='https://gotu.pt/collections/froddo-sandalia'>Froddo: Sandália (Sem Divisória)</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_sandalia_sem_divisoria.png?v=1739307845',
        imageAlt: 'Froddo Sandália Sem Divisória',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Sandal margin
        sizeMap: {
            197: { size: "29", width: "65mm" },
            209: { size: "31", width: "68mm" },
            216: { size: "32", width: "69mm" },
            224: { size: "33", width: "74mm" },
            248: { size: "37", width: "83mm" }, // Large gap
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Muris ---
    {
        id: 'muris-sapatilha',
        name: 'Muris Sapatilhas',
        filter: ["Resistentes à água", "Inverno", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-muris'>Muris: Sapatilhas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/murissapatilha.png?v=1729626195',
        imageAlt: 'Muris Sapatilhas',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
          126: { size: "20", width: "54mm" }, 132: { size: "21", width: "58mm" },
          140: { size: "22", width: "58mm" }, 149: { size: "23", width: "59mm" },
          153: { size: "24", width: "62mm" }, 159: { size: "25", width: "63mm" },
          168: { size: "26", width: "64mm" }, 174: { size: "27", width: "65mm" },
          179: { size: "28", width: "71mm" }, 186: { size: "29", width: "72mm" },
          191: { size: "30", width: "73mm" }, 198: { size: "31", width: "75mm" },
          205: { size: "32", width: "77mm" }, 211: { size: "33", width: "78mm" },
          219: { size: "34", width: "80mm" }, 224: { size: "35", width: "81mm" },
          231: { size: "36", width: "82mm" }, 240: { size: "37", width: "84mm" },
          245: { size: "38", width: "86mm" }, 252: { size: "39", width: "87mm" },
          260: { size: "40", width: "90mm" }, 266: { size: "41", width: "92mm" }
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'muris-sandalia',
        name: 'Muris Sandálias',
        filter: ["Verão", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-muris'>Muris: Sandálias</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Muris_sandalia.webp?v=1744047722',
        imageAlt: 'Muris Sandálias',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            126: { size: "20", width: "54mm" }, 132: { size: "21", width: "58mm" },
            134: { size: "22", width: "58mm" }, 149: { size: "23", width: "59mm" },
            153: { size: "24", width: "62mm" }, 159: { size: "25", width: "63mm" },
            168: { size: "26", width: "64mm" }, 174: { size: "27", width: "65mm" },
            179: { size: "28", width: "71mm" }, 186: { size: "29", width: "72mm" },
            191: { size: "30", width: "73mm" }, 198: { size: "31", width: "75mm" },
            205: { size: "32", width: "77mm" }, 211: { size: "33", width: "78mm" },
            219: { size: "34", width: "80mm" }, 224: { size: "35", width: "81mm" },
            231: { size: "36", width: "82mm" }, 240: { size: "37", width: "84mm" },
            245: { size: "38", width: "86mm" }, 252: { size: "39", width: "87mm" },
            260: { size: "40", width: "90mm" }, 266: { size: "41", width: "92mm" }
        },
        // warningCases removed - rely on auto-generation (assuming same logic as sapatilha)
    },
    // --- Mum Barefoot ---
    {
        id: 'mum-barefoot-adult',
        name: 'Mum Barefoot Sapatilhas Adulto',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/mum-barefoot'>Mum Barefoot</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/MUM_BAREFOOT.webp?v=1741879258',
        imageAlt: 'Mum Barefoot Sapatilhas Adulto',
        calculationType: 'margin',
        marginLogic: { base: 5, length: 6, minMargin: 5, maxMargin: 10 }, // Ensure these are correct
        sizeMap: {
            243: { size: "36", width: "88mm" }, 249: { size: "37", width: "90mm" },
            256: { size: "38", width: "93mm" }, 262: { size: "39", width: "95mm" },
            270: { size: "40", width: "96mm" }, 277: { size: "41", width: "98mm" },
            283: { size: "42", width: "100mm" },
        },
         // warningCases removed - rely on auto-generation (TESTING RECOMMENDED due to single-point ranges in original)
    },
    // --- Blanditos ---
    {
        id: 'blanditos-small',
        name: 'Blanditos (<36)',
        filter: ["Resistentes à água", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-blanditos'>Blanditos</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Antiga_59104f85-c5bc-4a92-b8d9-52ffee657c78.png?v=1727813513',
        imageAlt: 'Blanditos shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            115: { size: "18", width: "50mm" }, 120: { size: "19", width: "51mm" },
            129: { size: "20", width: "52mm" }, 135: { size: "21", width: "54mm" },
            140: { size: "22", width: "55mm" }, 146: { size: "23", width: "57mm" },
            151: { size: "24", width: "58mm" }, 159: { size: "25", width: "59mm" },
            166: { size: "26", width: "66mm" }, 173: { size: "27", width: "70mm" },
            180: { size: "28", width: "71mm" }, 185: { size: "29", width: "72mm" },
            192: { size: "30", width: "73mm" }, 199: { size: "31", width: "75mm" },
            206: { size: "32", width: "77mm" }, 213: { size: "33", width: "79mm" },
            219: { size: "34", width: "82mm" }, 225: { size: "35", width: "82mm" }
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'blanditos-large',
        name: 'Blanditos (36+)',
        filter: ["Resistentes à água", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/blanditos-adulto'>Blanditos Adultos</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditosmaisnova_6dc2fbdd-4797-4a55-b114-b775e95d9e8a.png?v=1727813659',
        imageAlt: 'Blanditos shoes (Size 36+)',
        calculationType: 'margin',
        marginLogic: { base: 5, length: 6, minMargin: 5, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            232: { size: "36", width: "85mm" }, 239: { size: "37", width: "85mm" },
            245: { size: "38", width: "89mm" }, 251: { size: "39", width: "90mm" },
            258: { size: "40", width: "91mm" }
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'blanditos-lonas-veganos',
        name: 'Blanditos Lonas & Veganos',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/colecao-blanditos-lonas'>Blanditos: Lonas & Veganos</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Lonas_1dd37b47-4b35-41d6-9375-1ebe973e753c.png?v=1727814189',
        imageAlt: 'Blanditos Lonas & Veganos shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            131: { size: "20", width: "57mm" }, 137: { size: "21", width: "59mm" },
            144: { size: "22", width: "61mm" }, 150: { size: "23", width: "62mm" },
            158: { size: "24", width: "63mm" }, 164: { size: "25", width: "64mm" },
            169: { size: "26", width: "66mm" }, 175: { size: "27", width: "67mm" },
            183: { size: "28", width: "71mm" }, 190: { size: "29", width: "72mm" },
            230: { size: "35", width: "81mm" }, 236: { size: "36", width: "82mm" },
            244: { size: "37", width: "84mm" }, 250: { size: "38", width: "86mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'blanditos-sapatilha-larga',
        name: 'Blanditos Sapatilha Sola Larga (2024)',
        filter: ["Resistentes à água", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-blanditos'>Blanditos: Sola Larga (2024)</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditoslondrespreview_b3d25761-603b-4dbc-89c3-949077d878cd.png?v=1733412466',
        imageAlt: 'Blanditos Sapatilha Sola Larga',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            127: { size: "20", width: "59mm" }, 136: { size: "21", width: "60mm" },
            140: { size: "22", width: "62mm" }, 146: { size: "23", width: "63mm" },
            153: { size: "24", width: "65mm" }, 160: { size: "25", width: "66mm" },
            166: { size: "26", width: "68mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Igor ---
    {
        id: 'igor-nemo',
        name: 'Igor Nemo',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/igor-sandalias'>Igor: Nemo</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/nemo.png?v=1718807196',
        imageAlt: 'Igor Nemo Sandalia',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            118: { size: "19", width: "58mm" }, 125: { size: "20", width: "59mm" },
            131: { size: "21", width: "60mm" }, 137: { size: "22", width: "60mm" },
            143: { size: "23", width: "61mm" }, 150: { size: "24", width: "63mm" },
            157: { size: "25", width: "64mm" }, 163: { size: "26", width: "66mm" },
            169: { size: "27", width: "68mm" }, 176: { size: "28", width: "69mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'igor-pantufas',
        name: 'Igor Pantufas',
        filter: ["Inverno", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/igor-pantufas'>Igor: Pantufas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/igorpantufamini.png?v=1727968148',
        imageAlt: 'Igor Pantufas',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            126: { size: "20", width: "59mm" }, 132: { size: "21", width: "59mm" },
            139: { size: "22", width: "61mm" }, 144: { size: "23", width: "62mm" },
            153: { size: "24", width: "63mm" }, 160: { size: "25", width: "66mm" },
            165: { size: "26", width: "68mm" }, 172: { size: "27", width: "69mm" },
            179: { size: "28", width: "71mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'blanditos-cerimonia',
        name: 'Blanditos Clássico / Cerimónia',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/blanditos-cerimonia?filter.v.availability=1'>Blanditos: Clássico / Cerimónia</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Cerimonia.png?v=1718307803',
        imageAlt: 'Blanditos Cerimonia shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            115: { size: "18", width: "50mm" }, 120: { size: "19", width: "51mm" },
            129: { size: "20", width: "52mm" }, 135: { size: "21", width: "54mm" },
            140: { size: "22", width: "55mm" }, 146: { size: "23", width: "57mm" },
            151: { size: "24", width: "58mm" }, 159: { size: "25", width: "59mm" },
            166: { size: "26", width: "60mm" }, 173: { size: "27", width: "63mm" },
            180: { size: "28", width: "71mm" }, 185: { size: "29", width: "72mm" },
            192: { size: "30", width: "73mm" }, 199: { size: "31", width: "75mm" },
            206: { size: "32", width: "77mm" }, 213: { size: "33", width: "79mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'blanditos-sandalia-castanha',
        name: 'Blanditos Sandália Aberta Sola Castanha',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Aberta Sola Castanha</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/castanha.png?v=1718378473',
        imageAlt: 'Blanditos Sandália Sola Castanha',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            169: { size: "26", width: "70mm" }, 175: { size: "27", width: "70mm" },
            183: { size: "28", width: "73mm" }, 189: { size: "29", width: "74mm" },
            196: { size: "30", width: "75mm" }, 204: { size: "31", width: "78mm" },
            210: { size: "32", width: "79mm" }, 215: { size: "33", width: "82mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'blanditos-sandalia-saona',
        name: 'Blanditos Sandália Saona 2024',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Saona 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Saona.png?v=1718305859',
        imageAlt: 'Blanditos Sandália Saona',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            168: { size: "26", width: "70mm" }, 175: { size: "27", width: "71mm" },
            182: { size: "28", width: "72mm" }, 187: { size: "29", width: "74mm" },
            193: { size: "30", width: "76mm" }, 200: { size: "31", width: "78mm" },
            206: { size: "32", width: "80mm" },
        },
         // warningCases removed - rely on auto-generation
    },
     {
        id: 'blanditos-sandalia-brisa',
        name: 'Blanditos Sandália Brisa 2024',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Brisa 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/solabranca.png?v=1718305859',
        imageAlt: 'Blanditos Sandália Brisa',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            125: { size: "20", width: "44mm" }, 131: { size: "21", width: "46mm" },
            138: { size: "22", width: "46mm" }, 147: { size: "23", width: "47mm" },
            152: { size: "24", width: "47mm" }, 157: { size: "25", width: "48mm" },
            167: { size: "26", width: "50mm" }, 171: { size: "27", width: "55mm" },
        },
        // KEEPING Manual warnings due to potential specific logic/overlaps
        warningCases: [
            { measurementMin: 70, measurementMax: 110, display: "👇👟", width: "", targetInnerSole: null },
            { measurementMin: 111, measurementMax: 117, display: "20", width: "44mm", targetInnerSole: 125 },
            { measurementMin: 123, measurementMax: 123, display: "21", width: "46mm", targetInnerSole: 131 },
            { measurementMin: 129, measurementMax: 130, display: "22", width: "46mm", targetInnerSole: 138 },
            { measurementMin: 136, measurementMax: 139, display: "23", width: "47mm", targetInnerSole: 147 },
            { measurementMin: 152, measurementMax: 159, display: "25", width: "48mm", targetInnerSole: 157 }, // Conflicting range in original
            { measurementMin: 167, measurementMax: 167, display: "26", width: "50mm", targetInnerSole: 167 }, // Conflicting range
            { measurementMin: 171, measurementMax: 171, display: "27", width: "55mm", targetInnerSole: 171 }, // Conflicting range
            { measurementMin: 169, measurementMax: 290, display: "🤚🩰", width: "", targetInnerSole: null }, // Needs consolidation
        ]
    },
    {
        id: 'blanditos-sandalia-isla',
        name: 'Blanditos Sandália Isla & Costa',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Isla & Costa</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Isla.png?v=1718381434',
        imageAlt: 'Blanditos Sandália Isla',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            125: { size: "20", width: "56mm" }, 131: { size: "21", width: "59mm" },
            138: { size: "22", width: "59mm" }, 147: { size: "23", width: "61mm" },
            155: { size: "24", width: "63mm" }, 160: { size: "25", width: "64mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'blanditos-sandalia-cielo',
        name: 'Blanditos Sandália Cielo 2024',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Cielo 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/3blanditoscielo2024_57937daf-b9d3-401c-96ef-c22e070f9f3f.png?v=1718302469',
        imageAlt: 'Blanditos Sandália Cielo',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            121: { size: "20", width: "49mm" }, 127: { size: "21", width: "49mm" },
            132: { size: "22", width: "51mm" }, 139: { size: "23", width: "51mm" },
            146: { size: "24", width: "53mm" }, 152: { size: "25", width: "54mm" },
            158: { size: "26", width: "56mm" }, 165: { size: "27", width: "56mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'blanditos-sandalia-agua',
        name: 'Blanditos Sandália Agua 2024',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Agua 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/3blanditosaqua2024_1d3d8f22-4664-42ad-ab42-cd0f2e741c47.png?v=1718302469',
        imageAlt: 'Blanditos Sandália Agua',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            130: { size: "20", width: "55mm" }, 137: { size: "21", width: "59mm" },
            144: { size: "22", width: "60mm" }, 151: { size: "23", width: "60mm" },
            158: { size: "24", width: "63mm" }, 166: { size: "25", width: "63mm" },
        },
         // warningCases removed - rely on auto-generation
    },
     {
        id: 'blanditos-sandalia-algodon',
        name: 'Blanditos Sandália Algodon 2024',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Algodon 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/3blanditosalgodon2024_29adfd0f-97cf-4c8e-a6c2-f190b5ef7e37.png?v=1718302469',
        imageAlt: 'Blanditos Sandália Algodon',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            131: { size: "20", width: "57mm" }, 138: { size: "21", width: "60mm" },
            143: { size: "22", width: "61mm" }, 152: { size: "23", width: "61mm" },
            156: { size: "24", width: "65mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'blanditos-sandalia-gota',
        name: 'Blanditos Sandália Gota 2024',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/blanditos-sandalia-aberta'>Blanditos: Sandália Gota 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/3blanditosgota2024_3479a3d0-e816-4216-9b69-7adb3084e07f.png?v=1718302469',
        imageAlt: 'Blanditos Sandália Gota',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            128: { size: "20", width: "59mm" }, 136: { size: "21", width: "59mm" },
            142: { size: "22", width: "60mm" }, 149: { size: "23", width: "62mm" },
            155: { size: "24", width: "64mm" }, 161: { size: "25", width: "65mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Lässig ---
    {
        id: 'lassig',
        name: 'Lässig',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-lassig'>Lässig</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/lassig_068b8864-9936-4d62-8d75-6c0069558500.png?v=1718307803',
        imageAlt: 'Lässig shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            125: { size: "19", width: "57mm" }, 133: { size: "20", width: "58mm" },
            140: { size: "21", width: "60mm" }, 147: { size: "22", width: "62mm" },
            155: { size: "23", width: "64mm" }, 162: { size: "24", width: "65mm" },
            172: { size: "25", width: "67mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Baby Lobitos ---
    {
        id: 'babylobitos', // Main lobitos
        name: 'Baby Lobitos',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/baby-lobitos-crianca'>Baby Lobitos</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Lobitos_122ddf65-3bd9-4706-b539-cc6b9135428d.png?v=1718307804',
        imageAlt: 'Baby Lobitos shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            133: { size: "21", width: "59mm" }, 141: { size: "22", width: "59mm" },
            146: { size: "23", width: "60mm" }, 154: { size: "24", width: "62mm" },
            160: { size: "25", width: "63mm" }, 165: { size: "26", width: "65mm" },
            172: { size: "27", width: "66mm" }, 180: { size: "28", width: "68mm" },
            186: { size: "29", width: "70mm" }, 191: { size: "30", width: "73mm" },
            197: { size: "31", width: "75mm" }, 205: { size: "32", width: "78mm" },
            214: { size: "33", width: "80mm" }, 220: { size: "34", width: "80mm" },
            226: { size: "35", width: "80mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'babylobitos-mini',
        name: 'Baby Lobitos Mini',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/baby-lobitos-crianca'>Baby Lobitos Mini</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Mini_lobitos.webp?v=1741970331',
        imageAlt: 'Baby Lobitos Mini shoes',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            105: { size: "16-17", width: "47mm" },
            117: { size: "18-19", width: "50mm" },
            130: { size: "20-21", width: "55mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'babylobitos-compas',
        name: 'Baby Lobitos - Sola 2024',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-baby-lobitos'>Baby Lobitos - Sola 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Babylobitoscompas_7c3fc9b6-e259-4096-bb30-1ca80ada52b3.png?v=1730731737',
        imageAlt: 'Baby Lobitos Sola 2024',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            141: { size: "22", width: "63mm" }, 146: { size: "23", width: "65mm" },
            154: { size: "24", width: "66mm" }, 160: { size: "25", width: "67mm" },
            165: { size: "26", width: "70mm" }, 171: { size: "27", width: "71mm" },
            176: { size: "28", width: "73mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'babylobitos-arcoiris',
        name: 'Baby Lobitos Arcoiris',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-baby-lobitos'>Baby Lobitos: Arcoiris</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Arcoiris.png?v=1718305859',
        imageAlt: 'Baby Lobitos Arcoiris shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            133: { size: "21", width: "58mm" }, 141: { size: "22", width: "60mm" },
            149: { size: "23", width: "62mm" }, 155: { size: "24", width: "63mm" },
            160: { size: "25", width: "65mm" }, 168: { size: "26", width: "66mm" },
            174: { size: "27", width: "68mm" }, 180: { size: "28", width: "69mm" },
            188: { size: "29", width: "70mm" }, 200: { size: "30", width: "80mm" },
            205: { size: "31", width: "81mm" }, 210: { size: "32", width: "83mm" },
            218: { size: "33", width: "85mm" }, 225: { size: "34", width: "86mm" },
            233: { size: "35", width: "88mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'babylobitos-mapis',
        name: 'Baby Lobitos Mapis',
        filter: ["Resistentes à água", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/baby-lobitos-mapis'>Baby Lobitos: Mapis</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/mappis.png?v=1718311309',
        imageAlt: 'Baby Lobitos Mapis shoes',
        calculationType: 'margin',
        marginLogic: { base: 5, length: 6, minMargin: 5, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            237: { size: "36", width: "95mm" }, 243: { size: "37", width: "96mm" },
            251: { size: "38", width: "97mm" }, 257: { size: "39", width: "100mm" },
            264: { size: "40", width: "100mm" }, 271: { size: "41", width: "102mm" },
            278: { size: "42", width: "104mm" }, 284: { size: "43", width: "105mm" },
            289: { size: "44", width: "106mm" },
        },
         // warningCases removed - rely on auto-generation (TESTING RECOMMENDED due to single-point ranges in original)
    },
    // --- Poppis ---
    {
        id: 'poppis',
        name: 'Poppis',
        filter: ["Resistentes à água", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-poppis'>Poppis</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/poppis_ab30c3c4-bd1b-4170-bd66-2d66016da83e.png?v=1718307803',
        imageAlt: 'Poppis shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            156: { size: "24", width: "67mm" }, 161: { size: "25", width: "70mm" },
            166: { size: "26", width: "70mm" }, 173: { size: "27", width: "72mm" },
            182: { size: "28", width: "74mm" }, 186: { size: "29", width: "76mm" },
            196: { size: "30", width: "77mm" }, 202: { size: "31", width: "78mm" },
            210: { size: "32", width: "80mm" }, 213: { size: "33", width: "82mm" },
            220: { size: "34", width: "83mm" }, 226: { size: "35", width: "84mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     // --- Igor Mendi ---
     {
        id: 'igor-mendi',
        name: 'Igor Galochas Mendi',
        filter: ["À prova de água", "Inverno", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/igor-galochas'>Igor: Galochas Mendi</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/igormendi.webp?v=1743540596',
        imageAlt: 'Igor Galochas Mendi',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            132: { size: "20", width: "61mm" }, 134: { size: "21", width: "61mm" },
            147: { size: "22", width: "65mm" }, 149: { size: "23", width: "64mm" },
            159: { size: "24", width: "68mm" }, 166: { size: "25", width: "68mm" },
            173: { size: "26", width: "71mm" }, 177: { size: "27", width: "71mm" },
            184: { size: "28", width: "73mm" },
        },
         // warningCases removed - rely on auto-generation
    },
    // --- Igor Yogi ---
     {
        id: 'igor-yogi-borreguito',
        name: 'Igor Galochas Yogi Borreguito',
        filter: ["À prova de água", "Inverno"],
        link: "<a href='https://gotu.pt/collections/igor-galochas'>Igor: Galochas Yogi Borreguito</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/igoryogi.png?v=1729628468',
        imageAlt: 'Igor Galochas Yogi Borreguito',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            120: { size: "20", width: "" }, 133: { size: "21", width: "" },
            138: { size: "22", width: "" }, 141: { size: "23", width: "" },
            149: { size: "24", width: "" }, 153: { size: "25", width: "" },
            158: { size: "26", width: "" }, 166: { size: "27", width: "" },
            174: { size: "28", width: "" }, 179: { size: "29", width: "71mm" },
            185: { size: "30", width: "72mm" }, 191: { size: "31", width: "74mm" },
            201: { size: "32", width: "75mm" },
        },
        // warningCases removed - rely on auto-generation
    },
 { // Victoria Botins
        id: 'victoria-botins',
        name: 'Victoria Botins',
        filter: ["Resistentes à água", "Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-victoria-botins'>Victoria: Botins</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/botins.png?v=1718310184',
        imageAlt: 'Victoria Botins',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            132: { size: "22", width: "62mm" }, 138: { size: "23", width: "62mm" },
            146: { size: "24", width: "65mm" }, 151: { size: "25", width: "68mm" },
            158: { size: "26", width: "69mm" }, 165: { size: "27", width: "70mm" },
            173: { size: "28", width: "70mm" }, 178: { size: "29", width: "74mm" },
            184: { size: "30", width: "75mm" }, 193: { size: "31", width: "77mm" },
            198: { size: "32", width: "79mm" }, 204: { size: "33", width: "83mm" },
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'victoria-barefoot-botins',
        name: 'Victoria Botins Barefoot',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-victoria-barefoot'>Victoria: Botins Barefoot</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/victoriabarefootbotinsmini.png?v=1727970056',
        imageAlt: 'Victoria Botins Barefoot',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            123: { size: "20", width: "59mm" }, 129: { size: "21", width: "61mm" },
            136: { size: "22", width: "64mm" }, 142: { size: "23", width: "65mm" },
            149: { size: "24", width: "65mm" }, 157: { size: "25", width: "66mm" },
            162: { size: "26", width: "69mm" }, 168: { size: "27", width: "71mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'victoria-barefoot-sapatilhas',
        name: 'Victoria Barefoot Coleção 2025',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/victoria-barefoot-sapatilha'>Victoria: Barefoot Coleção 2025</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Victoriabarefootsapatilha.png?v=1738256761',
        imageAlt: 'Victoria Barefoot Sapatilhas 2025',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            131: { size: "20", width: "61mm" }, 137: { size: "21", width: "62mm" },
            142: { size: "22", width: "63mm" }, 149: { size: "23", width: "65mm" },
            155: { size: "24", width: "66mm" }, 162: { size: "25", width: "69mm" },
            167: { size: "26", width: "72mm" }, 173: { size: "27", width: "68mm" },
            181: { size: "28", width: "70mm" }, 190: { size: "29", width: "73mm" },
            196: { size: "30", width: "76mm" }, 202: { size: "31", width: "76mm" },
            211: { size: "32", width: "78mm" }, 216: { size: "33", width: "79mm" },
            228: { size: "34", width: "80mm" },
        },
         // warningCases removed - rely on auto-generation
    },
    {
        id: 'victoria-barefoot-sapatilhas-adulto',
        name: 'Victoria Barefoot Sapatilhas Adulto',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/victoria-barefoot-sapatilhas-adulto'>Victoria: Barefoot Sapatilhas Adulto</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Victoria_Adulto_Sapatilha.png?v=1741717240',
        imageAlt: 'Victoria Barefoot Sapatilhas Adulto',
        calculationType: 'margin',
        marginLogic: { base: 5, length: 6, minMargin: 5, maxMargin: 10 }, // Ensure these are correct
        sizeMap: {
            235: { size: "36", width: "83mm" }, 242: { size: "37", width: "86mm" },
            248: { size: "38", width: "87mm" }, 255: { size: "39", width: "88mm" },
            260: { size: "40", width: "90mm" }, 265: { size: "41", width: "91mm" },
            270: { size: "42", width: "92mm" }, 275: { size: "43", width: "93mm" }
        },
        // warningCases removed - rely on auto-generation (TESTING RECOMMENDED)
    },
    {
        id: 'victoria-galochas',
        name: 'Victoria Galochas',
        filter: ["À prova de água", "Inverno"],
        link: "<a href='https://gotu.pt/collections/victoria-galochas'>Victoria: Galochas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Victoria_galocha.webp?v=1741717406',
        imageAlt: 'Victoria Galochas',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            145: { size: "22", width: "60mm" }, 151: { size: "23", width: "61mm" },
            156: { size: "24", width: "62mm" }, 165: { size: "25", width: "63mm" },
            169: { size: "26", width: "66mm" }, 178: { size: "27", width: "68mm" },
            185: { size: "28", width: "69mm" }, 190: { size: "29", width: "71mm" },
            197: { size: "30", width: "72mm" }, 204: { size: "31", width: "73mm" },
            210: { size: "32", width: "74mm" }, 215: { size: "33", width: "76mm" },
            224: { size: "34", width: "78mm" }, 231: { size: "35", width: "79mm" },
            236: { size: "36", width: "80mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Coucouçava ---
    {
        id: 'coucoucava',
        name: 'Coucouçava',
        filter: ["Todo o ano", "Resistentes à água", "Inverno"],
        link: "<a href='https://gotu.pt/collections/colecao-coucoucava'>Coucouçava</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/coucoucava.png?v=1718305859',
        imageAlt: 'Coucouçava shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            130: { size: "20", width: "56mm" }, 135: { size: "21", width: "60mm" },
            143: { size: "22", width: "61mm" }, 150: { size: "23", width: "64mm" },
            155: { size: "24", width: "64mm" }, 160: { size: "25", width: "66mm" },
            168: { size: "26", width: "70mm" },
        },
         // warningCases removed - rely on auto-generation
    },
    {
        id: 'coucoucava-crescidos',
        name: 'Coucouçava Sola Crescidos',
        filter: ["Todo o ano", "Resistentes à água"],
        link: "<a href='https://gotu.pt/collections/colecao-coucoucava'>Coucouçava Sola Crescidos</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Coucoucava_Sola_grande_d7a5c781-913d-4a1e-ade8-a085f666d82d.webp?v=1743013868',
        imageAlt: 'Coucouçava Sola Crescidos shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            160: { size: "24", width: "65mm" }, 167: { size: "25", width: "66mm" },
            175: { size: "26", width: "68mm" }, 181: { size: "27", width: "69mm" },
            188: { size: "28", width: "72mm" }, 195: { size: "29", width: "75mm" },
            201: { size: "30", width: "76mm" }, 209: { size: "31", width: "78mm" },
            216: { size: "32", width: "79mm" },
        },
         // warningCases removed - rely on auto-generation
    },
       // --- Pablosky ---
     {
        id: 'pablosky-sandalia',
        name: 'Pablosky Sandália',
        filter: ["Todo o ano", "Verão"],
        link: "<a href='https://gotu.pt/collections/pablosky'>Pablosky Sandália</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Pablosky_Sandalia.webp?v=1742305935',
        imageAlt: 'Pablosky Sandália',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            163: { size: "25", width: "65mm" }, 170: { size: "26", width: "68mm" },
            176: { size: "27", width: "69mm" }, 183: { size: "28", width: "71mm" },
        },
    }
  ,
  {
        id: 'pablosky-lona',
        name: 'Pablosky Lona',
        filter: ["Todo o ano", "Resistentes à água"],
        link: "<a href='https://gotu.pt/collections/pablosky'>Pablosky Lona</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Pablosky_Lona.webp?v=1742305935',
        imageAlt: 'Pablosky Lona',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            130: { size: "21", width: "57mm" }, 136: { size: "22", width: "59mm" },
            141: { size: "23", width: "61mm" }, 149: { size: "24", width: "64mm" },
            157: { size: "25", width: "66mm" },
        },
    },
    {
        id: 'pablosky-glitter',
        name: 'Pablosky Glitter',
        filter: ["Todo o ano", "Resistentes à água"],
        link: "<a href='https://gotu.pt/collections/pablosky'>Pablosky Glitter</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Pablosky_glitter.webp?v=1742305935',
        imageAlt: 'Pablosky Glitter',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 },
        sizeMap: {
            136: { size: "21", width: "58mm" }, 144: { size: "22", width: "60mm" },
            150: { size: "23", width: "62mm" }, 156: { size: "24", width: "64mm" },
            164: { size: "25", width: "66mm" },
        },
    },

    {
        id: 'pablosky-olimpia-estrela',
        name: 'Pablosky - Olimpia Estrela',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/pablosky'>Pablosky - Olimpia Estrela</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Pablosky_Sandalia_Estrela.webp?v=1744305296',
        imageAlt: 'Pablosky - Olimpia Estrela',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Default logic
        sizeMap: {
            140: { size: "21", width: "54mm" },
            145: { size: "22", width: "60mm" },
            152: { size: "23", width: "61mm" },
            158: { size: "24", width: "61mm" },
            163: { size: "25", width: "62mm" },
            171: { size: "26", width: "62mm" },
            177: { size: "27", width: "65mm" }
        },
    },
    {
        id: 'pablosky-sandalia-sola-fechada',
        name: 'Pablosky - Sandália Sola Fechada',
        filter: ["Verão"], 
        link: "<a href='https://gotu.pt/collections/pablosky'>Pablosky - Sandália Sola Fechada</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Pablosky_Sandalia_fechada.webp?v=1744305297',
        imageAlt: 'Pablosky - Sandália Sola Fechada',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Default logic
        sizeMap: {
            122: { size: "19", width: "57mm" },
            129: { size: "20", width: "57mm" },
            133: { size: "21", width: "57mm" },
            140: { size: "22", width: "61mm" },
            148: { size: "23", width: "63mm" },
            152: { size: "24", width: "65mm" },
            159: { size: "25", width: "68mm" },
            165: { size: "26", width: "70mm" },
            173: { size: "27", width: "69mm" }
        },
    },
    {
        id: 'pablosky-sandalia-sola-aberta',
        name: 'Pablosky - Sandália Sola Aberta',
        filter: ["Verão"], // Example filter, adjust as needed
        link: "<a href='https://gotu.pt/collections/pablosky'>Pablosky - Sandália Sola Aberta</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Pablosky_Sandalia_Aberta.webp?v=1744305296',
        imageAlt: 'Pablosky - Sandália Sola Aberta',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Default logic
        sizeMap: {
            152: { size: "25", width: "68mm" },
            163: { size: "26", width: "70mm" },
            170: { size: "27", width: "70mm" },
            176: { size: "28", width: "73mm" }
        },      
    },
     // --- Waterlemon ---
     {
        id: 'waterlemon-maleavel',
        name: 'Waterlemon Maleável',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/waterlemon-maleavel'>Waterlemon: Maleável</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/maleavel.png?v=1724939935',
        imageAlt: 'Waterlemon Maleável shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            130: { size: "20/21", width: "" }, 143: { size: "22/23", width: "" },
            151: { size: "24/25", width: "" }, 169: { size: "26/27", width: "" },
            185: { size: "28/29", width: "" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'waterlemon-pantufas',
        name: 'Waterlemon Pantufas',
        filter: ["Todo o ano", "Inverno"],
        link: "<a href='https://gotu.pt/collections/colecao-waterlemon-pantufas'>Waterlemon: Pantufas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Pantufawaterlemon.png?v=1718377210',
        imageAlt: 'Waterlemon Pantufas',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            139: { size: "21/22", width: "53mm" }, 151: { size: "23/24", width: "60mm" },
            168: { size: "25/26", width: "62mm" }, 182: { size: "27/28", width: "63mm" },
            195: { size: "29/30", width: "69mm" }, 200: { size: "31/32", width: "76mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'waterlemon-galochas',
        name: 'Waterlemon Galochas',
        filter: ["Inverno", "À prova de água"],
        link: "<a href='https://gotu.pt/collections/colecao-waterlemon-galochas'>Waterlemon: Galochas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/galochawaterlemon.png?v=1718378210',
        imageAlt: 'Waterlemon Galochas',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            142: { size: "22", width: "58mm" }, 158: { size: "24", width: "64mm" },
            170: { size: "26", width: "65mm" }, 182: { size: "28", width: "69mm" },
            196: { size: "30", width: "73mm" }, 211: { size: "32", width: "75mm" },
            222: { size: "34", width: "81mm" }, 238: { size: "36", width: "81mm" }
        },
        // warningCases removed - rely on auto-generation
    },
     {
        id: 'waterlemon-sandalia',
        name: 'Waterlemon Sandália',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/colecao-waterlemon-sandalia'>Waterlemon: Sandália</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/sandaliawaterlemon.png?v=1718377210',
        imageAlt: 'Waterlemon Sandália',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            135: { size: "22", width: "62mm" }, 140: { size: "23", width: "64mm" },
            150: { size: "24", width: "65mm" }, 155: { size: "25", width: "67mm" },
            164: { size: "26", width: "67mm" }, 170: { size: "27", width: "70mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Banannas ---
    {
        id: 'banannas',
        name: 'Banannas Baby Shoes',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-banannas'>Banannas: Baby Shoes</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Banannas_646212da-611b-4362-8c00-273608c16886.png?v=1718310328',
        imageAlt: 'Banannas Baby Shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            105: { size: "20", width: "" }, 115: { size: "21.5", width: "" },
            125: { size: "22.5", width: "" },
        },
        // warningCases removed - rely on auto-generation
    },
     // --- Dodo ---
     {
        id: 'dodo-sandalia',
        name: 'Dodo Sandália',
        filter: ["Verão"],
        link: "<a href='https://gotu.pt/collections/colecao-dodo'>Dodo: Sandália</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Dodo.png?v=1718307804',
        imageAlt: 'Dodo Sandália',
        calculationType: 'margin',
        marginLogic: { base: 3, length: 5, minMargin: 3, maxMargin: 7 }, // Ensure these are correct
        sizeMap: {
            115: { size: "18", width: "56mm" }, 123: { size: "19", width: "57mm" },
            131: { size: "20", width: "58mm" }, 137: { size: "21", width: "60mm" },
            145: { size: "22", width: "62mm" }, 151: { size: "23", width: "63mm" },
            156: { size: "24", width: "64mm" }, 165: { size: "25", width: "66mm" },
            171: { size: "26", width: "68mm" }, 180: { size: "27", width: "70mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'dodo-thermo',
        name: 'Dodo Thermo',
        filter: ["Resistentes à água", "Inverno"],
        link: "<a href='https://gotu.pt/collections/dodo-thermo'>Dodo: Thermo</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/dodothermo.png?v=1718307804',
        imageAlt: 'Dodo Thermo boots',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            125: { size: "20", width: "59mm" }, 130: { size: "21", width: "62mm" },
            137: { size: "22", width: "62mm" }, 142: { size: "23", width: "64mm" },
            149: { size: "24", width: "66mm" }, 158: { size: "25", width: "68mm" },
            166: { size: "26", width: "69mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Bunny Barefoot ---
     {
        id: 'bunny-barefoot',
        name: 'Bunny Barefoot',
        filter: ["Todo o ano", "Resistentes à água"],
        link: "<a href='https://gotu.pt/collections/bunny-barefoot'>Bunny Barefoot</a>",
        imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/bunny.png?v=1718377210",
        imageAlt: 'Bunny Barefoot shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 5, minMargin: 8, maxMargin: 12 }, // Ensure these are correct
        sizeMap: {
            121: { size: "19", width: "52mm" }, 126: { size: "20", width: "52mm" },
            133: { size: "21", width: "54mm" }, 142: { size: "22", width: "57mm" },
            148: { size: "23", width: "60mm" }, 154: { size: "24", width: "60mm" },
            161: { size: "25", width: "62mm" }, 168: { size: "26", width: "63mm" },
            174: { size: "27", width: "64mm" }, 182: { size: "28", width: "73mm" },
            189: { size: "29", width: "75mm" }, 195: { size: "30", width: "77mm" },
            202: { size: "31", width: "78mm" }, 209: { size: "32", width: "80mm" },
            216: { size: "33", width: "82mm" }, 222: { size: "34", width: "83mm" }
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'bunny-girafinhas',
        name: 'Bunny Barefoot Girafinhas',
        filter: ["Todo o ano", "Resistentes à água"],
        link: "<a href='https://gotu.pt/collections/bunny-barefoot-girafinha'>Bunny Barefoot: Girafinhas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/girafinhas.png?v=1718309593',
        imageAlt: 'Bunny Barefoot Girafinhas',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            118: { size: "18", width: "50mm" }, 123: { size: "19", width: "52mm" },
            132: { size: "20", width: "58mm" }, 140: { size: "21", width: "59mm" },
            146: { size: "22", width: "60mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // --- Chameleon --- (Lookup type, no changes needed)
    {
        id: 'chameleon',
        name: 'Chameleon',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/chameleon'>Big Toes: Chameleon</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/chameleon.png?v=1718377211',
        imageAlt: 'Chameleon shoes',
        calculationType: 'lookup',
        lookupTable: [
            { min: -Infinity, max: 108, size: "👇👟", width: "" },
            { min: 109, max: 115, size: "M", width: "" },
            { min: 116, max: 125, size: "L", width: "" },
            { min: 126, max: 135, size: "XL", width: "" },
            { min: 136, max: Infinity, size: "🤚🩰", width: "" },
        ]
    },
    // --- Little Dutch ---
    {
        id: 'little-dutch-galochas',
        name: 'Little Dutch Galochas',
        filter: ["À prova de água", "Inverno"],
        link: "<a href='https://gotu.pt/collections/little-dutch-galochas'>Little Dutch: Galochas</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/LTgalocha.png?v=1718310863',
        imageAlt: 'Little Dutch Galochas',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            153: { size: "22/23", width: "" }, 165: { size: "24/25", width: "" },
            178: { size: "26/27", width: "69mm" }
        },
        // warningCases removed - rely on auto-generation
    },
     // --- Victoria Pantufa ---
     {
        id: 'victoria-pantufa',
        name: 'Victoria Pantufa',
        filter: ["Todo o ano", "Inverno"],
        link: "<a href='https://gotu.pt/collections/colecao-victoria-pantufas'>Victoria: Pantufa</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/PantufaV.png?v=1718311060',
        imageAlt: 'Victoria Pantufa',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            106: { size: "18", width: "" }, 123: { size: "19", width: "" },
            129: { size: "20", width: "" }, 136: { size: "21", width: "" },
            142: { size: "22", width: "" }, 149: { size: "23", width: "" },
            154: { size: "25", width: "" }, 161: { size: "26", width: "" },
            165: { size: "27", width: "" }, 170: { size: "28", width: "" },
            182: { size: "29", width: "" }, 190: { size: "30", width: "" },
        },
        // warningCases removed - rely on auto-generation
    },
     // --- Victoria Velcro ---
     {
        id: 'victoria-velcro-aberto',
        name: 'Victoria Aberto',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-velcro-aberto'>Victoria: Aberto</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/velcroaberto.png?v=1718307804',
        imageAlt: 'Victoria Aberto shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            102: { size: "18", width: "45mm" }, 109: { size: "19", width: "48mm" },
            115: { size: "20", width: "50mm" }, 129: { size: "21", width: "50mm" },
            135: { size: "22", width: "53mm" }, 140: { size: "23", width: "55mm" },
            145: { size: "24", width: "55mm" }, 150: { size: "25", width: "57mm" },
            155: { size: "26", width: "60mm" }, 162: { size: "27", width: "60mm" },
            168: { size: "28", width: "65mm" }, 175: { size: "29", width: "65mm" },
            182: { size: "30", width: "68mm" }, 188: { size: "31", width: "68mm" },
            195: { size: "32", width: "" }, 201: { size: "33", width: "" },
            208: { size: "34", width: "" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'victoria-barefoot-2024',
        name: 'Victoria Barefoot Coleção 2024',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-victoria-barefoot'>Victoria: Barefoot Coleção 2024</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/barefootvictoria.png?v=1718307803',
        imageAlt: 'Victoria Barefoot 2024 shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            117: { size: "19", width: "58mm" }, 124: { size: "20", width: "59mm" },
            130: { size: "21", width: "60mm" }, 138: { size: "22", width: "62mm" },
            142: { size: "23", width: "63mm" }, 148: { size: "24", width: "65mm" },
            154: { size: "25", width: "67mm" }, 160: { size: "26", width: "68mm" },
            167: { size: "27", width: "71mm" }, 181: { size: "28", width: "68mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'victoria-laco',
        name: 'Victoria Laço',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/colecao-victoria-laco'>Victoria: Laço</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/victorialaco.png?v=1718307803',
        imageAlt: 'Victoria Laço shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11 }, // Ensure these are correct
        sizeMap: {
            111: { size: "18", width: "" }, 117: { size: "19", width: "" },
            122: { size: "20", width: "53mm" }, 127: { size: "21", width: "54mm" },
            133: { size: "22", width: "58mm" }, 138: { size: "23", width: "62mm" },
            147: { size: "24", width: "62mm" }, 153: { size: "25", width: "62mm" },
            160: { size: "26", width: "65mm" }, 167: { size: "27", width: "" },
            172: { size: "28", width: "" }, 181: { size: "29", width: "" },
            186: { size: "30", width: "" },
        },
         // warningCases removed - rely on auto-generation
    },
     // --- Froddo ---
     {
        id: 'froddo-sapatilha-canva',
        name: 'Froddo Sapatilha Canva',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/froddo-sapatilha'>Froddo: Sapatilha Canva</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/FroddoSapatilhaCanva.png?v=1739298818',
        imageAlt: 'Froddo Sapatilha Canva',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11, threshold: 230, altBase: 5, altLength: 6 }, // Ensure these are correct
      sizeMap: {

            143: { size: "21", width: "60mm" }, 
            149: { size: "22", width: "63mm" }, 
            155: { size: "23", width: "63mm" }, 
            162: { size: "24", width: "65mm" }, 
            167: { size: "25", width: "61mm" },
            176: { size: "26", width: "68mm" }, 
            183: { size: "27", width: "72mm" },
            192: { size: "28", width: "73mm" }, 
            197: { size: "29", width: "75mm" },
            202: { size: "30", width: "75mm" }, 
            210: { size: "31", width: "78mm" },
            217: { size: "32", width: "78mm" },
            224: { size: "33", width: "81mm" }, 
            229: { size: "34", width: "82mm" },
            236: { size: "35", width: "84mm" }, 
            242: { size: "36", width: "88mm" }, 
            249: { size: "37", width: "90mm" },
            256: { size: "38", width: "92mm" }, 
            263: { size: "39", width: "92mm" }, 
            272: { size: "40", width: "95mm" }, 
            277: { size: "41", width: "95mm" },

        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'froddo-sapatilha-couro',
        name: 'Froddo Sapatilha Couro',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/froddo-sapatilha'>Froddo: Sapatilha Couro</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_Sapatilha_Couro.png?v=1739300310',
        imageAlt: 'Froddo Sapatilha Couro',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11, threshold: 230, altBase: 5, altLength: 6 }, // Ensure these are correct
  sizeMap: {
            139: { size: "21", width: "61mm" }, 143: { size: "22", width: "62mm" },
            150: { size: "23", width: "63mm" }, 162: { size: "25", width: "67mm" },
            169: { size: "26", width: "67mm" }, 185: { size: "28", width: "71mm" },
            200: { size: "30", width: "75mm" }, 206: { size: "31", width: "76mm" },
            210: { size: "32", width: "78mm" }, 217: { size: "33", width: "79mm" },
            226: { size: "34", width: "81mm" }, 233: { size: "35", width: "82mm" },
            239: { size: "36", width: "88mm" }, 246: { size: "37", width: "89mm" },
            251: { size: "38", width: "82mm" }, 256: { size: "39", width: "92mm" },
            265: { size: "40", width: "94mm" }, 272: { size: "41", width: "95mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'froddo-sapatilha-couro-malha',
        name: 'Froddo Couro e Malha',
        filter: ["Todo o ano"],
        link: "<a href='https://gotu.pt/collections/froddo-sapatilha'>Froddo: Couro e Malha</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_Sapatilha_Couro_Malha.png?v=1739300917',
        imageAlt: 'Froddo Couro e Malha shoes',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11, threshold: 230, altBase: 5, altLength: 6 }, // Ensure these are correct
        sizeMap: {
            139: { size: "21", width: "62mm" },
            146: { size: "22", width: "63mm" },
            152: { size: "23", width: "64mm" },
            158: { size: "24", width: "65mm" },
            164: { size: "25", width: "67mm" },
            171: { size: "26", width: "67mm" },
            178: { size: "27", width: "71mm" },
            184: { size: "28", width: "71mm" },
            191: { size: "29", width: "74mm" },
            199: { size: "30", width: "75mm" },
            204: { size: "31", width: "75mm" },
            211: { size: "32", width: "75mm" },
            219: { size: "33", width: "81mm" },
            238: { size: "36", width: "87mm" },
            246: { size: "37", width: "89mm" },
            251: { size: "38", width: "91mm" },
            256: { size: "39", width: "92mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'froddo-botas-first-step',
        name: 'Froddo Botas First Step',
        filter: ["Todo o ano", "Inverno"],
        link: "<a href='https://gotu.pt/collections/froddo-bota-termica'>Froddo: Botas First Step</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_Botas_First_Step.png?v=1739304258',
        imageAlt: 'Froddo Botas First Step',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11, threshold: 230, altBase: 5, altLength: 6 }, // Ensure these are correct
        sizeMap: {
            139: { size: "21", width: "61mm" }, 159: { size: "24", width: "65mm" },
            166: { size: "25", width: "66mm" }, 170: { size: "26", width: "67mm" },
            185: { size: "28", width: "71mm" }, 191: { size: "29", width: "74mm" },
            198: { size: "30", width: "76mm" }, 202: { size: "31", width: "77mm" },
            212: { size: "33", width: "80mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    {
        id: 'froddo-botas-tex',
        name: 'Froddo Botas Tex',
        filter: ["Todo o ano", "Inverno"],
        link: "<a href='https://gotu.pt/collections/froddo-bota-tex'>Froddo: Botas Tex</a>",
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Froddo_Bota_Tex.png?v=1739304968',
        imageAlt: 'Froddo Botas Tex',
        calculationType: 'margin',
        marginLogic: { base: 8, length: 4, minMargin: 8, maxMargin: 11, threshold: 230, altBase: 5, altLength: 6 }, // Ensure these are correct
        sizeMap: {
            172: { size: "27", width: "71mm" }, 215: { size: "32", width: "80mm" },
            221: { size: "33", width: "81mm" }, 226: { size: "34", width: "82mm" },
            235: { size: "35", width: "87mm" }, 245: { size: "36", width: "87mm" },
            249: { size: "37", width: "91mm" }, 255: { size: "38", width: "92mm" },
            261: { size: "39", width: "93mm" }, 269: { size: "40", width: "93mm" },
        },
        // warningCases removed - rely on auto-generation
    },
    // Add MEIAS last if you want it sorted to the bottom naturally (or handle in sort logic)
    {
        id: 'meias',
        name: 'Meias',
        filter: 'Todo o ano', // Filter for the meias section
        link: "<a href='https://gotu.pt/collections/meias-e-perneiras'>Temos meias respeitadoras, vê aqui!</a>",
        calculationType: 'special', // Indicate special handling needed
        imageUrls: [ // Store multiple URLs if needed
            'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/condormeias.png?v=1727971498',
            'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/lassigmeias.png?v=1727972482',
            'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/bigtoesmeias.png?v=1728516524'
        ],
        imageAlt: 'Meias respeitadoras',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/condormeias.png?v=1727971498' // Initial image
    }
];